import { css } from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import variables from 'styles/vendor/bootstrap/variables'

const bleedAmount = rem(-variables.gutterWidth / 1.5)

export const mobileBleedStyles = css`
  margin-left: ${bleedAmount};
  margin-right: ${bleedAmount};

  ${mediaQueryUp.tablet} {
    margin-left: 0;
    margin-right: 0;
  }
`
